import { ServiceKitList } from './ServiceKitList';
import { ServiceKitItem } from './ServiceKitItem';
import { Route } from 'react-router-dom';
import * as React from 'react';

export const ServiceKitView = () => {
    return (
        <>
            <Route path="/service-kits" exact component={ServiceKitList} />
            <Route path="/service-kits/:guid" exact component={ServiceKitItem} />
            <Route path={`/service-kits/:guid/edit`} exact component={ServiceKitItem} />
            <Route path={`/service-kits/create`} exact component={ServiceKitItem} />
        </>
    );
};
